import 'react-loading-skeleton/dist/skeleton.css';
import 'react-table-6/react-table.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toggle/style.css';
import 'sanitize.css';
import './App.css';
import './index.css';
import './style/react-select.css';
import './style/react-table.css';
import './style/react-toggle.css';
import './style/reactjs-popup.css';

import { createBrowserHistory as createHistory } from 'history';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import _App from './App';

const App = _App;

export { App, createHistory, React, ReactDOM, Router, Suspense };
